module.exports = __webpack_public_path__ + "static/media/Used Cat Telehandlers - Toromont Cat.32b28e1b.jpg";